import { LOCATION_CHANGE } from 'react-router-redux';

const initialState = {
  key: undefined,
  items: [],
};

const find = (items, key) => items.findIndex(item => item.key === key);

const locationChange = (state, { payload: { action, ...location } }) => {
  const currentIdx = find(state.items, state.key);
  const locationIdx = find(state.items, location.key);
  switch (action) {
    case 'POP':
      if (locationIdx > -1) {
        return { ...state, key: location.key };
      }
      return { key: location.key, items: [...state.items, location] };
    case 'PUSH':
      return { key: location.key, items: [...state.items.slice(0, currentIdx + 1), location] };
    case 'REPLACE':
      return { key: location.key, items: [...state.items.slice(0, locationIdx), location] };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return locationChange(state, action);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/location-history.js